"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasSplitterWorkflow = void 0;
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasSplitterWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
    constructor() {
        super();
        this.inputPin = [Types_1.InputPin.INPUT];
        this.outputPin = [
            Types_1.OutputPin.OUTPUT,
            Types_1.OutputPin.SPLITTER_OUTPUT1,
            Types_1.OutputPin.SPLITTER_OUTPUT2,
        ];
        this.type = Types_1.WorkflowType.SPLITTER;
        this.settings = this.getDefaultSettings();
        this.customProcess = {};
        this.schema = validation_1.SplitterSchema;
    }
    getDefaultSettings() {
        return {
            stage_name: '',
            condition1: null,
            condition2: null,
            next_workflow_ids: {
                next_workflow: null,
                splitter_workflow1: null,
                splitter_workflow2: null,
            },
        };
    }
    setNextWorkflow(pin, next_workflow_id) {
        if (pin === Types_1.OutputPin.SPLITTER_OUTPUT1) {
            this.settings.next_workflow_ids.splitter_workflow1 =
                next_workflow_id;
        }
        else if (pin === Types_1.OutputPin.SPLITTER_OUTPUT2) {
            this.settings.next_workflow_ids.splitter_workflow2 =
                next_workflow_id;
        }
        this.setDefaultNextWorkflow(pin, next_workflow_id);
    }
    getNextWorkflows() {
        return {
            [Types_1.OutputPin.OUTPUT]: this.getDefaultNextWorkflow(),
            [Types_1.OutputPin.SPLITTER_OUTPUT1]: this.settings.next_workflow_ids.splitter_workflow1,
            [Types_1.OutputPin.SPLITTER_OUTPUT2]: this.settings.next_workflow_ids.splitter_workflow2,
        };
    }
    setCustomProcess(s, p) { }
    getProperties() {
        return [
            {
                attribute: 'stage_name',
                datasource: null,
                label: 'SPLITTER_STAGE_NAME',
                type: 'text',
                mandatory: true,
                value: this.settings.stage_name,
            },
            {
                attribute: 'condition1',
                datasource: null,
                label: 'SPLITTER_CONDITION1',
                type: 'advanced-query',
                mandatory: false,
                value: this.settings.condition1,
            },
            {
                attribute: 'condition2',
                datasource: null,
                label: 'SPLITTER_CONDITION2',
                type: 'advanced-query',
                mandatory: false,
                value: this.settings.condition2,
            },
        ];
    }
}
exports.CanvasSplitterWorkflow = CanvasSplitterWorkflow;
